
import { mapState } from 'vuex'
export default {
  props: {
    property: {
      type: Object,
      default: () => { },
    },
    available: {
      type: Boolean,
      default: Math.random() < 0.5,
    },
    url: {
      type: String,
      default: `listing/11`,
    },
    showFooterBtn: {
      type: Boolean,
      default: true,
    },
    showApplicationMenu: {
      type: Boolean,
      default: false,
    },
    showSelect: {
      type: Boolean,
      default: false,
    },
    makeSmall: {
      type: Boolean,
      default: false,
    },
    showMenuForUserDashboard: {
      type: Boolean,
      default: false,
    },
    hideEdit: {
      type: Boolean,
      default: false,
    },
    hideDelete: {
      type: Boolean,
      default: false,
    },
    // medias: {
    //   type: Array,
    //   default: () => [
    //     { fileName: require('~/assets/img/listing/listing-placeholder.png') },
    //   ],
    // },
  },
  data: () => ({
    loading: false,
    select: false,
    // show:true
  }),
  created() {
    console.log(this.property)
  },
  computed: {
    ...mapState('taxonomy', ['taxonomy']),
  },
  methods: {
    selectedListing(obj) {
      this.$emit('listingSelected', obj)
    },
    toggle() {
      if (!this.select) {
        this.select = true
        this.selectedListing({ id: this.property.id, select: true })
      } else {
        this.select = false
        this.selectedListing({ id: this.property.id, select: false })
      }
    },
    listingSelectedForView(property) {
      console.log(property)
      this.$emit('listingSelectedForView', property)
    },
    listingSelectedForEdit(propertyId) {
      console.log(propertyId)
      this.$emit('listingSelectedForEdit', propertyId)
    },
    listingSelectedForDelete(propertyId) {
      console.log(propertyId)
      this.$emit('listingSelectedForDelete', propertyId)
    },
    listingSelectedForViewApplication(property) {
      console.log(property)
      this.$emit('listingSelectedForViewApplication', property.id)
    },
  },
}
